// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"3591db72","1050":"d9427d1d","2320":"8140a6ae","4936":"b0071303","8057":"8140a6ae"}[chunkId] + ".chunk.css";
};